export class Preference {
    public preferenceId: number;
    public prefType: string;
    public dataTableId: string;
    public configuration: any;
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/search/models/preference.model.ts